<h2 mat-dialog-title>
  @if (!empty) {
    <span>{{'reports.editReportsTemplate' | translate}}</span>
  }
  @if (empty) {
    <span>{{'newReportsTemplate' | translate}}</span>
  }
  <p class="text-muted" style="font-size:14px;">{{'reports.subtitle' | translate}}</p>
</h2>

<mat-dialog-content>
  <div class="pt-2 ">

    <section class="mt-1 mb-3 rounded m-auto w-100" id="section">

      <form [formGroup]="reportForm">
        <!-- <input type="text" class="form-control" formControlName="value"> -->
        <mat-form-field appearance="outline" class="w-100 ">
          <mat-label>{{'displayName' | translate}}</mat-label>
          <input matInput type="text" class="form-control" placeholder="{{'displayName' | translate}}" formControlName="displayName" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 ">
          <mat-label>{{'tridys.name' | translate}}</mat-label>
          <input matInput type="text" class="form-control" placeholder="{{'tridys.name' | translate}}" formControlName="name">
          <mat-hint>{{'taskTemplates.nameHint' | translate }}</mat-hint>
        </mat-form-field>

        @if (isAdmin) {
          <div class="form-control p-3 my-2 d-flex justify-content-between w-100">
            <div class="d-flex align-items-center">
              <label>{{'reports.protected' | translate}}</label>
              <mat-icon class="ms-2 text-muted" style="font-size:18px;height:18px;" matTooltip="{{'reports.protected_hint' | translate}}">info</mat-icon>
            </div>
            <mat-slide-toggle formControlName="protected"></mat-slide-toggle>
          </div>
        }

        <mat-form-field appearance="outline"  class="w-100 mt-3 p-0">
          <mat-label>{{'contentTypes.contentType' | translate}}</mat-label>
          <mat-select formControlName="contentTypeId" required>
            <mat-option value="" > - </mat-option>
            @for (content of contentTypesList; track content) {
              <mat-option value="{{content.id}}" >{{content.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div>
          <span class="text-muted">{{'reports.columns' | translate}}</span>
          <div>
            <span class="custom-hint" style="color:var(--warmOrange);">{{'reports.column_keys' | translate}}</span>
            <p class="custom-hint">{{'reports.columnsHint' | translate}}</p>
          </div>

          <div>
            <button mat-button (click)="addField()" class="secondary-gray-button mb-3 mt-2" id="btn-add">
              <mat-icon>add_circle</mat-icon> {{'reports.add_column' | translate}}
            </button>

            <button mat-button class="secondary-gray-button mb-3 mt-2 ms-3" id="btn-add" [matMenuTriggerFor]="wt_workTask">
              <mat-icon>add_circle</mat-icon> {{'reports.import_from_workTask' | translate}}
            </button>

            <mat-menu #wt_workTask="matMenu">
              @for (wt of workTaskTemplatesList; track wt; let index_wt = $index) {
                <button mat-menu-item (click)="importColumnFromWorkTask(wt, wt['id']);">{{wt.title}}</button>
              }
            </mat-menu>
          </div>

          <div class="list-group" cdkDropList (cdkDropListDropped)="dropResultFields($event)">
            @for (field of reportForm.value.resultFields; track field; let index = $index) {
              <div>
                <mat-card class="mb-1" cdkDrag>
                  <mat-card-content class="py-0">
                    <div class="d-flex align-items-center" style="justify-content: space-between;">
                      <div>
                        <div class=" d-flex flex-column justify-content-between align-items-start mt-1 mb-1 w-100" (click)="editResultField(field, index);">
                          <span style="cursor: pointer;">{{field.displayName}}</span>
                          <label class="text-muted custom-label"> {{field.key}}: {{field.type}}</label>
                        </div>
                      </div>
                      <button class="delete-button" style="vertical-align: middle;" mat-icon-button (click)="deleteResultField(index);">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            }
          </div>

        </div>

        <mat-expansion-panel class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'workTask.advanced_settings' | translate}} (Optional)
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div>
            <span class="text-muted">{{'reports.sorting' | translate}}</span>
            <p class="custom-hint">{{'reports.sorting_description' | translate}}</p>
            <!-- <mat-form-field appearance="outline" class="w-100 mt-2">
            <mat-label>{{'reports.key' | translate}}</mat-label>
            <input matInput type="text" class="form-control" placeholder=" {{'reports.sorted_by' | translate}}" formControlName="sortedBy">
          </mat-form-field> -->

          <div>
            @if( reportForm.value.sort ){
              <div class="list-group my-2" cdkDropList (cdkDropListDropped)="dropSortingOptions($event)">
                @for( sortOption of reportForm.value.sort; track sortOption; let index = $index ){
                  <div class="list-group-item d-flex align-items-center justify-content-between" cdkDrag>
                    <div class=" d-flex flex-column justify-content-between align-items-start mt-1 mb-1 w-100">
                      <span>{{sortOption.key}}</span>
                      <label class="text-muted custom-label"> {{sortOption.direction}}</label>
                    </div>
                    <button class="delete-button" style="vertical-align: middle;" mat-icon-button (click)="deleteSortKeyDirection(index);">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }

            <mat-accordion class="my-2">
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)" >
                <mat-expansion-panel-header>
                  <mat-panel-title> {{'reports.sorting_direction' | translate}} </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-form-field appearance="outline"  class="w-100 mt-3 p-0">
                  <mat-label>{{'reports.key' | translate}}</mat-label>
                  <mat-select formControlName="sortingKey">
                    @for (field of reportForm.value.resultFields; track field) {
                      <mat-option value="{{field.key}}" [disabled]="checkExistingKeyDescription(field.key)" >{{field.displayName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline"  class="w-100 mt-3 p-0">
                  <mat-label>{{'reports.direction' | translate}}</mat-label>
                  <mat-select formControlName="sortingDirection">
                    <mat-option value="asc" > {{'ASC' | translate}} </mat-option>
                    <mat-option value="desc" > {{'DESC' | translate}} </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-action-row>
                  <button mat-button class="w-100" [disabled]="!reportForm.value.sortingKey || !reportForm.value.sortingDirection" (click)="accordion().closeAll();addSortKeyDirection()"> {{'reports.add_sort_option' | translate}}</button>
                </mat-action-row>
              </mat-expansion-panel>
            </mat-accordion>

          </div>
        </div>

        <!-- <div class="mt-3 mb-2 py-2">
        <span class="text-muted text-uppercase">{{'reports.options' | translate}}</span>
        <p class="custom-hint">{{'reports.options_description' | translate}}</p>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'reports.limit' | translate}}</mat-label>
          <input matInput type="text" placeholder="{{'reports.limit' | translate}}" formControlName="limit">
        </mat-form-field>
      </div> -->

      <div class="mt-3 mb-2">
        <span class="text-muted">{{'reports.fixedFilters' | translate}}</span>
        <p class="custom-hint">{{'reports.fixedFiltersHint' | translate}}</p>
        @if (loadedLegacyFixedFilters) {
        <button mat-button type="button" [matMenuTriggerFor]="addRootFilterMenu"
          class="secondary-gray-button mb-3 mt-2" id="btn-add">
          <mat-icon>add_circle</mat-icon> {{'add' | translate}}
        </button>
        <mat-menu #addRootFilterMenu="matMenu">
          <button mat-menu-item type="button" (click)="addFixedFilter()">{{'predicateFilter.addComparison' | translate}}</button>
          <button mat-menu-item type="button" (click)="addFilterGroup(reportForm.value.fixedFilters, 'and')">{{'predicateFilter.addAndGroup' | translate}}</button>
          <button mat-menu-item type="button" (click)="addFilterGroup(reportForm.value.fixedFilters, 'or')">{{'predicateFilter.addOrGroup' | translate}}</button>
        </mat-menu>

        <ng-template #filterTree let-nodes="nodes">
          <div class="list-group" cdkDropList [cdkDropListData]="nodes" (cdkDropListDropped)="dropFixedFilters($event, nodes)">
            @for (filter of nodes; track filter; let index = $index) {
              @if (isFilterGroup(filter)) {
                <mat-card class="mb-2 filter-group-card" cdkDrag>
                  <mat-card-content>
                    <div class="d-flex align-items-center gap-2 mb-2">
                      <mat-form-field appearance="outline" class="filter-group-operation">
                        <mat-label>{{'reports.groupOperation' | translate}}</mat-label>
                        <mat-select [value]="groupOperation(filter)" (selectionChange)="setFilterGroupOperation(filter, $event.value)">
                          <mat-option value="and">{{'predicateFilter.and' | translate}}</mat-option>
                          <mat-option value="or">{{'predicateFilter.or' | translate}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-icon-button type="button" (click)="deleteFixedFilter(index, nodes)"
                        [attr.aria-label]="'delete' | translate">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                    <div class="filter-group-children">
                      <ng-container *ngTemplateOutlet="filterTree; context: {nodes: groupChildren(filter)}"></ng-container>
                      <button mat-button type="button" [matMenuTriggerFor]="addChildFilterMenu">
                        <mat-icon>add_circle</mat-icon> {{'add' | translate}}
                      </button>
                      <mat-menu #addChildFilterMenu="matMenu">
                        <button mat-menu-item type="button" (click)="addFixedFilter(groupChildren(filter))">{{'predicateFilter.addComparison' | translate}}</button>
                        <button mat-menu-item type="button" (click)="addFilterGroup(groupChildren(filter), 'and')">{{'predicateFilter.addAndGroup' | translate}}</button>
                        <button mat-menu-item type="button" (click)="addFilterGroup(groupChildren(filter), 'or')">{{'predicateFilter.addOrGroup' | translate}}</button>
                      </mat-menu>
                    </div>
                  </mat-card-content>
                </mat-card>
              } @else {
                <mat-card class="mb-1" cdkDrag>
                  <mat-card-content class="py-0">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex flex-column align-items-start my-1 w-100" (click)="editFixedFilter(filter, index, nodes)">
                        <span style="cursor: pointer;">{{filter.displayName || filter.key || filter.field}}</span>
                        <label class="text-muted custom-label">{{filter.key || filter.field}} ({{filter.operator}})
                          @if (filter.type!='date' && filter.type!='dateTime') {
                            <span>{{filter.value}}</span>
                          }
                          @if (filter.type=='date') {
                            <span>{{isDate(filter.value,filter.operator)}}</span>
                          }
                          @if (filter.type=='dateTime') {
                            <span>{{isDateTime(filter.value,filter.operator)}}</span>
                          }
                        </label>
                      </div>
                      <button class="delete-button" mat-icon-button type="button" (click)="deleteFixedFilter(index, nodes)"
                        [attr.aria-label]="'delete' | translate">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            }
          </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="filterTree; context: {nodes: reportForm.value.fixedFilters}"></ng-container>
        } @else {
          <app-work-task-template-filters
            [predicates]="reportForm.value.fixedFilters"
            [showHeader]="false"
            [requireValue]="true"
            (predicatesChange)="onJsonFiltersChange($event)">
          </app-work-task-template-filters>
        }

        @if (coexistingLegacyFixedFilters.length > 0) {
          <div class="mt-3">
            <span class="text-muted">{{'reports.legacyFixedFilters' | translate}}</span>
            @for (filter of coexistingLegacyFixedFilters; track filter; let index = $index) {
              <mat-card class="mb-1">
                <mat-card-content class="py-0">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column align-items-start my-1 w-100"
                      (click)="editCoexistingLegacyFilter(filter, index)" style="cursor: pointer;">
                      <span>{{filter.displayName || filter.key || filter.field}}</span>
                      <label class="text-muted custom-label">{{filter.key || filter.field}} ({{filter.operator}}) {{filter.value}}</label>
                    </div>
                    <button mat-icon-button type="button" (click)="deleteCoexistingLegacyFilter(index)"
                      [attr.aria-label]="'delete' | translate">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>
            }
          </div>
        }
      </div>
    </mat-expansion-panel>



    <!-- <div class="mt-3 mb-2">
    <span class="text-muted text-uppercase">{{'reports.ui_filters' | translate}}</span>
    <p class="custom-hint">{{'reports.ui_filterHint' | translate}}</p>
    <div class="list-group">
      <div *ngFor="let filter of reportForm.value.filters; let index = index;">
        <mat-card class="mb-1">
          <mat-card-content class="py-0">
            <div class="d-flex align-items-center" style="justify-content: space-between;">
              <div>
                <div class="d-flex flex-column justify-content-between align-items-start mt-1 mb-1 w-100" (click)="editFilter(filter, index);" >
                  <span style="cursor: pointer;"> {{filter.displayName}}</span>
                  <label class="text-muted custom-label">{{filter.key}}  ({{filter.operator}})</label>
                </div>
              </div>
              <button class="delete-button" style="vertical-align: middle;" mat-icon-button (click)="deleteFilter(index);">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <button mat-button
      (click)="addFilter()"
      class="secondary-gray-button mb-3 mt-2"
      id="btn-add"
      >
      <mat-icon>add_circle</mat-icon> {{'reports.add_filter' | translate}}
    </button>
  </div> -->

</form>
</section>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >
    {{'cancel' | translate}}
  </button>
  <button mat-button class="orange-button" [disabled]="!canSaveReport()"
  (click)="onSave();">{{'save' | translate}}</button>
</mat-dialog-actions>
